import "../../style/scss/FormActions.scss";
import { FaTrashAlt } from "react-icons/fa";
import CustomButton from "./CustomButton";
import { useModalBusy } from "./modalBusy";

export default function FormActions(props) {
  const { withBusy } = useModalBusy();
  const {
    onSubmitAsync,
    onSaveAsync,
    submitLabel,
    doneLabel,
    onCancelAsync,
    cancelLabel,
    onDeleteAsync,
    deleteLabel,
    requiredHint,
  } = props;

  const localOnSubmitAsync =
    onSubmitAsync ||
    onSaveAsync ||
    props?.formObject?.formProps?.onSubmitAsync ||
    props?.formObject?.formProps?.onSaveAsync ||
    props?.formObject?.formProps?.onSubmit ||
    props?.formObject?.formProps?.onSave ||
    props?.Submit;

  const localOnCancelAsync =
    onCancelAsync || props?.formObject?.formProps?.onCancelAsync || props?.Cancel;

  const localOnDeleteAsync =
    onDeleteAsync || props?.formObject?.formProps?.onDeleteAsync || props?.Delete;

  const primaryLabel = submitLabel || doneLabel || "Save";
  const deleteAriaLabel = deleteLabel || "Delete";

  const wrapAsync = (fn) => (e) => {
    if (!fn) return;
    void withBusy(async () => {
      await fn(e);
    }).catch((err) => console.error(err));
  };

  return (
    <div className="form-actions">
      {localOnSubmitAsync && (
        <CustomButton type="submit" variant="contained" color="primary">
          {primaryLabel}
        </CustomButton>
      )}
      {localOnCancelAsync && (
        <CustomButton
          type="button"
          variant="outlined"
          color="secondary"
          className="form-actions__cancel"
          onClick={wrapAsync(localOnCancelAsync)}
        >
          {cancelLabel || "Cancel"}
        </CustomButton>
      )}
      {localOnDeleteAsync && (
        <button
          type="button"
          className="form-actions__delete"
          aria-label={deleteAriaLabel}
          title={deleteAriaLabel}
          onClick={wrapAsync(localOnDeleteAsync)}
        >
          <FaTrashAlt aria-hidden />
        </button>
      )}
      {requiredHint ? (
        <span className="form-actions__required" data-testid="form-required-hint">
          <span className="tab-required-dot" aria-hidden />
          Required
        </span>
      ) : null}
      {props.children ? (
        <div className="form-actions__extra">{props.children}</div>
      ) : null}
    </div>
  );
}
